// Run `fn` when the main thread is idle, or after `timeout` ms at the latest. requestIdleCallback is
// missing in Safari and never fires in a background tab, so fall back to a timer there.
export function whenIdle(fn, timeout = 2000) {
    if ('requestIdleCallback' in window && !document.hidden) {
        return window.requestIdleCallback(fn, {timeout});
    }
    return window.setTimeout(fn, 1);
}

// Give the browser a chance to handle input and paint between chunks of work.
export function yieldToMain() {
    if (typeof window.scheduler?.yield === 'function') {
        return window.scheduler.yield();
    }
    if (typeof window.scheduler?.postTask === 'function') {
        return window.scheduler.postTask(() => {}, {priority: 'user-visible'});
    }
    return new Promise((resolve) => setTimeout(resolve, 0));
}
